import { AppError } from './AppError'

export class GraphQLClientError extends AppError {
  constructor(
    message: string,
    public readonly operationName: string,
    public readonly variables?: Record<string, unknown>,
    options?: ErrorOptions,
  ) {
    super(message, 'GRAPHQL_CLIENT_ERROR', { operationName, variables }, options)
    this.name = 'GraphQLClientError'
  }

  toLogContext() {
    return {
      ...super.toLogContext(),
      operationName: this.operationName,
      variables: this.variables,
    }
  }
}
